/* Ciokarrua · Free Shipping Bar — real-time update
   Ascolta eventi cart change e aggiorna il messaggio + barra. */
(function() {
  'use strict';
  if (window.__cioFsBound) return;
  window.__cioFsBound = true;

  const moneyFormat = (cents, currency) => {
    const eur = (cents / 100).toFixed(2).replace('.', ',');
    return `€${eur}`;
  };

  async function refresh() {
    const bars = document.querySelectorAll('[data-cio-fs]');
    if (!bars.length) return;
    let cart;
    try {
      cart = await (await fetch('/cart.js', {headers:{'Accept':'application/json'}})).json();
    } catch(e) { return; }

    bars.forEach(bar => {
      const threshold = parseInt(bar.dataset.threshold, 10);
      const currency = bar.dataset.currency || 'EUR';
      // Mercato rilevato lato Liquid ("in Italia" / "in Europa"). Sempre esplicito.
      const region = bar.dataset.region || '';
      const regionSuffix = region ? ` ${region}` : '';
      const reachedMsg = bar.dataset.reachedMsg || 'Spedizione gratuita inclusa';
      // Stringhe tradotte passate da Liquid (cio-t) — fallback IT
      const tAlmost = bar.dataset.tAlmost || 'Ci sei quasi!';
      const tAdd = bar.dataset.tAdd || 'Aggiungi';
      const tForfree = bar.dataset.tForfree || 'per la spedizione gratuita';
      const tFree = bar.dataset.tFree || 'Spedizione gratuita';
      const tFrom = bar.dataset.tFrom || 'da';

      const total = cart.total_price || 0;
      const remaining = threshold - total;
      const reached = remaining <= 0;
      const pct = Math.min(100, Math.round((total / threshold) * 100));

      const textEl = bar.querySelector('[data-cio-fs-text]');
      const amountEl = bar.querySelector('[data-cio-fs-amount]');
      const fillEl = bar.querySelector('[data-cio-fs-fill]');

      if (bar.classList.contains('cio-fs--cart') || bar.classList.contains('cio-fs--pdp')) {
        if (reached) {
          bar.classList.add('cio-fs--reached');
          if (textEl) textEl.innerHTML = `<span class="cio-fs__lead">${reachedMsg.replace(/🎉\s*|✓\s*/, '')}</span>`;
          if (fillEl) fillEl.style.width = '100%';
        } else {
          bar.classList.remove('cio-fs--reached');
          if (textEl) textEl.innerHTML = `<span class="cio-fs__lead">${tAlmost}</span> ${tAdd} <strong data-cio-fs-amount>${moneyFormat(remaining, currency)}</strong> ${tForfree}${regionSuffix}`;
          if (fillEl) fillEl.style.width = pct + '%';
        }
      } else {
        // topbar / pdp: messaggio statico, aggiorna solo amount se in modalità remaining
        if (total === 0) {
          textEl && (textEl.textContent = `🚚 ${tFree}${regionSuffix} ${tFrom} ${moneyFormat(threshold, currency)}`);
        } else if (reached) {
          textEl && (textEl.textContent = `✓ ${reachedMsg}`);
        } else {
          if (amountEl) amountEl.textContent = moneyFormat(remaining, currency);
        }
      }
    });
  }

  // Listen to cart events
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  // Horizon custom events
  document.addEventListener('cart-update', refresh);
  // Fallback: any form submit + intercepted fetch
  document.addEventListener('submit', (e) => {
    if (e.target && (e.target.action || '').includes('/cart/')) setTimeout(refresh, 400);
  });
  // Patch fetch to detect /cart/add or /cart/change
  const origFetch = window.fetch;
  window.fetch = async function(input, init) {
    const url = (typeof input === 'string') ? input : (input && input.url);
    const isCartMut = url && /\/cart\/(add|change|update|clear)/.test(url);
    const res = await origFetch.apply(this, arguments);
    if (isCartMut && res.ok) setTimeout(refresh, 100);
    return res;
  };
  // Initial refresh on load (in case server-rendered cart count is stale)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
